import { queryOptions } from '@tanstack/react-query';
import { SystemDesignAlertsModel } from '~/shared/models/system/SystemDesignAlertsModel';
import { listSystemDesignAlerts } from '~/services/api/fetchers/systemDesignAlerts.api';

export const listSystemDesignAlertsQuery = (systemName: string) =>
  queryOptions({
    queryKey: ['listSystemDesignAlerts', { systemName }],
    queryFn: async () => {
      const response = await listSystemDesignAlerts(systemName);
      return new SystemDesignAlertsModel(response);
    },
  });
